import { render, staticRenderFns } from "./AcessarView.vue?vue&type=template&id=071f4db4&scoped=true"
import script from "./AcessarView.vue?vue&type=script&lang=js"
export * from "./AcessarView.vue?vue&type=script&lang=js"
import style0 from "./AcessarView.vue?vue&type=style&index=0&id=071f4db4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f4db4",
  null
  
)

export default component.exports